var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2488_39817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.19611 4.78277L8.05549 9.90973C8.1055 10.2082 8.37526 10.4278 8.69194 10.4278H15.1373C15.4539 10.4278 15.7236 10.2082 15.7737 9.90973L16.6331 4.78277C16.7222 4.25121 16.1005 3.87411 15.6342 4.17681L13.9269 5.28505L12.3704 3.79934C12.1187 3.55907 11.7106 3.55907 11.4589 3.79934L9.90237 5.28505L8.19501 4.17681C7.7288 3.87411 7.10695 4.25113 7.19611 4.78277ZM9.61856 6.58886C9.87444 6.75497 10.2179 6.724 10.4367 6.51515L11.9146 5.10446L13.3925 6.51511C13.6113 6.724 13.9547 6.75493 14.2106 6.58882L15.1243 5.99577L14.5876 9.19729H9.24155L8.70492 5.99581L9.61856 6.58886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9141 3.00391C12.27 3.00391 12.5586 2.72846 12.5586 2.38867C12.5586 2.04889 12.27 1.77344 11.9141 1.77344C11.5581 1.77344 11.2695 2.04889 11.2695 2.38867C11.2695 2.72846 11.5581 3.00391 11.9141 3.00391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4258 3.61914C16.7817 3.61914 17.0703 3.34369 17.0703 3.00391C17.0703 2.66412 16.7817 2.38867 16.4258 2.38867C16.0698 2.38867 15.7812 2.66412 15.7812 3.00391C15.7812 3.34369 16.0698 3.61914 16.4258 3.61914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.40234 3.61914C7.75831 3.61914 8.04688 3.34369 8.04688 3.00391C8.04688 2.66412 7.75831 2.38867 7.40234 2.38867C7.04638 2.38867 6.75781 2.66412 6.75781 3.00391C6.75781 3.34369 7.04638 3.61914 7.40234 3.61914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9805 15.3906H15.5951V12.2734C15.5951 11.9337 15.3065 11.6582 14.9505 11.6582H8.92056C8.56461 11.6582 8.27603 11.9337 8.27603 12.2734V14.1602H2.89062C2.53467 14.1602 2.24609 14.4356 2.24609 14.7754V22.1582C2.24609 22.498 2.53467 22.7734 2.89062 22.7734H20.9805C21.3364 22.7734 21.625 22.498 21.625 22.1582V16.0059C21.625 15.6661 21.3364 15.3906 20.9805 15.3906ZM3.53516 15.3906H8.27603V21.543H3.53516V15.3906ZM9.56509 12.8887H14.306V21.543H9.56509V12.8887ZM20.3359 21.543H15.5951V16.6211H20.3359V21.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9336 14.1191H11.2891C10.9331 14.1191 10.6445 14.3946 10.6445 14.7344C10.6445 15.0741 10.9331 15.3496 11.2891 15.3496V17.1953C11.2891 17.5351 11.5776 17.8105 11.9336 17.8105C12.2895 17.8105 12.5781 17.5351 12.5781 17.1953V14.7344C12.5781 14.3946 12.2895 14.1191 11.9336 14.1191Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2488_39817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 21,
    fill: "white",
    transform: "translate(0.933594 1.77344)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame2);
export default __webpack_public_path__ + "static/media/Frame-2.98f2439446efecb3d8e635a4f5c60849.svg";
export { ForwardRef as ReactComponent };